var render = function render(){var _vm=this,_c=_vm._self._c;return _c('be-form-group',_vm._b({staticClass:"range-slider"},'be-form-group',_vm.widgetProps,false),[_c('div',{staticClass:"d-flex align-items-baseline"},[_c('div',{ref:"el",staticClass:"w-50",attrs:{"disabled":_vm.disabled || _vm.min === _vm.max}}),_c('div',{staticClass:"w-50 px-4"},[_vm._v(_vm._s(_vm.formatter(_vm.value)))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }